var token = null
var refreshToken = null

export const setToken = (t) => { token = t }
export const getToken = () => token

export const setRefreshToken = (t) => { refreshToken = t }
export const getRefreshToken = () => refreshToken
